<template>
  <Banner
    :canCloseBanner="false"
    :showBanner="showBanner"
  >
    <template #content>
      <span
        data-test-id="RoleInfoBanner__content"
      >
        <strong>{{ role }} Permissions</strong>
        {{ bannerText }}
        <Link
          :href="$options.kbUrl"
          isMatchText
          target="_blank"
          text="Learn more"
        />
        {{ bannerTextAfter }}
      </span>
    </template>
  </Banner>
</template>
<script>
import { Banner, Link } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModuleMap,
  UserRoleConsts,
} from 'client/util/Constants';
import { mapState } from 'vuex';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const { helpDesk, manager, readOnly } = UserRoleConsts;
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'RoleInfoBanner',

  components: {
    Banner,
    Link,
  },

  kbUrl: KbArticleUrls.roles,

  computed: {
    ...mapState(settingsModule, ['role']),

    bannerText() {
      if (this.role === helpDesk) {
        return 'You can manage users in JumpCloud.';
      }

      if (this.role === manager) {
        return 'You can manage devices, groups, and users in JumpCloud.';
      }

      if (this.role === readOnly) {
        return 'You can view information in JumpCloud.';
      }

      return '';
    },

    bannerTextAfter() {
      if (this.role === helpDesk) {
        return 'about what Help Desk Admins can do.';
      }

      if (this.role === manager) {
        return 'about what Manager Admins can do.';
      }

      if (this.role === readOnly) {
        return 'about what Read Only Admins can do.';
      }

      return '';
    },

    showBanner() {
      if (this.role === helpDesk || this.role === manager || this.role === readOnly) {
        return true;
      }

      return false;
    },
  },
};
</script>
